import * as React from 'react';
import { SvgIcon } from '@mui/material';
function wrapWithSvgIcon(component, props) {
    return React.createElement(SvgIcon, Object.assign({}, props), component);
}
function SvgUserReportedEmails(props) {
    return wrapWithSvgIcon(React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.5 13a3.501 3.501 0 00-3.5 3.5c0 1.932 1.568 3.5 3.5 3.5s3.5-1.568 3.5-3.5-1.568-3.5-3.5-3.5zm.35 5.25h-.7v-.7h.7v.7zm0-1.4h-.7v-2.1h.7v2.1z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.55 17c-.02-.17-.05-.33-.05-.5 0-2.76 2.24-5 5-5 .92 0 1.76.26 2.5.69V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h8.55zM12 10.5L5 7V5l7 3.5L19 5v2l-7 3.5z" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "UserReportedEmails_svg__clip0_22583_229067" },
                React.createElement("path", { d: "M0 0h24v24H0z" })))), props);
}
export default SvgUserReportedEmails;
//# sourceMappingURL=UserReportedEmails.js.map